function projectInputsAreRequiredIfOthersHaveEntry(fieldInputs) {
    function _somethingHasInput() {
        return _.find(fieldInputs, (x) => x.hasValue()) !== undefined;
    }

    function _updateState() {
        let somethingHasInput = _somethingHasInput();
        _.each(fieldInputs, function (fieldInput) {
            fieldInput.setIsRequired(somethingHasInput)
        });
    }
    _updateState();

    _.each(fieldInputs, function (fieldInput) {
        fieldInput.onChange(_updateState);
    }.bind(this));
}

function projectInputIsRequiredIfOthersHasEntry(fieldInput, otherFieldInputs) {
     function _somethingHasInput() {
        return _.find(otherFieldInputs, (x) => x.hasValue()) !== undefined;
    }

    function _updateState() {
        let somethingHasInput = _somethingHasInput();
        fieldInput.setIsRequired(somethingHasInput);
    }
    _updateState();

    _.each(otherFieldInputs, function (fieldInput) {
        fieldInput.onChange(_updateState);
    }.bind(this));
}